import React from 'react';

export const useHover = <T extends HTMLElement>(target: React.RefObject<T>): boolean => {
  const [hovering, setHovering] = React.useState(false);

  const onMouseEnter = (): void => setHovering(true);
  const onMouseLeave = (): void => setHovering(false);

  React.useEffect(
    // eslint-disable-next-line consistent-return
    () => {
      const { current } = target;
      if (current) {
        current.addEventListener('mouseenter', onMouseEnter);
        current.addEventListener('mouseleave', onMouseLeave);

        return (): void => {
          current.removeEventListener('mouseenter', onMouseEnter);
          current.removeEventListener('mouseleave', onMouseLeave);
        };
      }
    },
    [target] // Recall only if ref changes
  );

  return hovering;
};

export const useFocus = <T extends HTMLElement>(target: React.RefObject<T>): boolean => {
  const [focusing, setFocusing] = React.useState(false);

  const onFocus = (): void => setFocusing(true);
  const onBlur = (): void => setFocusing(false);

  React.useEffect(
    // eslint-disable-next-line consistent-return
    () => {
      const { current } = target;
      if (current) {
        current.addEventListener('focus', onFocus);
        current.addEventListener('blur', onBlur);

        return (): void => {
          current.removeEventListener('focus', onFocus);
          current.removeEventListener('blur', onBlur);
        };
      }
    },
    [target] // Recall only if ref changes
  );

  return focusing;
};
